import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PortfolioBrutalist from "./components/PortfolioBrutalist";
import ProcessSection from "./components/ProcessSection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="map-website">
      <Header />
      <main className="main-content">
        <HeroSection />
        <AboutSection />
        <PortfolioBrutalist />
        <ProcessSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
